/**
 * MegaRTL Icon Block JS
 * Mandatory ES6 placeholder to satisfy strict requirements.
 */

export default class IconBlock {
    constructor() {
        // No dynamic logic required for basic icon display.
    }
}
